<div class="loading-box" *ngIf="pageService.isPageLoading || show">
    <img src="./assets/img/loader.gif" alt="imagem de carregamento"/>
    <h1  dssTypography type="figure4">{{title || pageService.loadingTextTitle}}</h1>
    <p dssTypography type="caption">{{subtitle || pageService.loadingTextSubtitle}}</p>
</div>